module.exports = __webpack_public_path__ + "static/media/berntHugenholtz.2c2eb907.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/berntHugenholtz.jpg
// module id = 1668
// module chunks = 1